module.exports = __webpack_public_path__ + "static/media/check-grey.c78ba7df.svg";